import { Link, useNavigate } from 'react-router';
import { XMarkIcon, CheckIcon } from '@heroicons/react/24/outline';
import LocationBase from '../core/form/LocationBase';
import { useFormContext } from 'react-hook-form';
import usePatchParams from '../parameters/usePatchParams';
import { useCaseNodeParams, useNode } from '@/stores/nodeStore';
import useBetterCostDataModal from './useBetterCostDataModal';

const LocationEditForm = () => {
  const node = useNode();
  const caseParams = useCaseNodeParams();
  const navigate = useNavigate();
  const { patchPrimary } = usePatchParams();
  const { handleSubmit } = useFormContext();
  const paramSchema = node?.params?.find(param => param.type === 'location');
  const param = caseParams[paramSchema?.name];
  const { checkForSuggestion, betterCostDataModal } = useBetterCostDataModal({
    onComplete: () => navigate('..'),
  });

  const onSubmit = async (data, event) => {
    event.preventDefault();

    const value = data?.location?.address ? data.location : null;
    await patchPrimary(paramSchema.name, value);

    const hasSuggestion = await checkForSuggestion();
    if (!hasSuggestion) {
      navigate('..');
    }
  };

  if (!node) {
    return null;
  }

  return (
    <>
      <div className="shadow-md p-2 m-2 rounded-sm">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-1">
            <div>
              <LocationBase name={paramSchema?.name} value={param?.primary?.value} autoFocus shouldValidate={false} />
            </div>
            <div className="flex gap-2 justify-end">
              <Link to={'..'} replace className="btn btn-xs px-1 btn-ghost border-zinc-400">
                <XMarkIcon className="h-5 w-5 text-zinc-400" />
              </Link>
              <button type="submit" className="btn btn-xs px-1 text-white bg-purple-500 border-purple-500">
                <CheckIcon className="h-5 w-5" />
              </button>
            </div>
          </div>
        </form>
      </div>
      {betterCostDataModal}
    </>
  );
};

export default LocationEditForm;
